/*
 * PhotoHouse unpublished Preview: canonical Shopify variant -> product media.
 * A frame selection never relies on the old filtered/Flickity carousel's
 * rendering order. Uses only verified [data-media-id] and existing product media.
 */
(function(){
 'use strict';
 function arr(root,sel){return Array.prototype.slice.call(root.querySelectorAll(sel));}
 function kind(s){
   s=String(s||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
   if(/printing only|print only|without frame|no frame|unframed|ללא מסגרת|הדפסה בלבד|הדפס בלבד/.test(s))return 'print';
   if(/wenge|wenga|וונגה|ונגה/.test(s))return 'wenge';
   if(/black|שחור/.test(s))return 'black';
   if(/amber|ענבר/.test(s))return 'amber';
   return '';
 }
 function mount(article){
   if(article.dataset.phSelectedFrameMounted==='1')return;
   var main=article.querySelector('.ctm_product_gallery_main');
   var rail=article.querySelector('[data-ph-v7-rail]');
   var holder=arr(article,'.product__variant-holder').find(function(h){
     var label=h.querySelector('label'),sel=h.querySelector('select.product__variant');
     return label&&sel&&/frame|מסגר/i.test(label.textContent||'');
   });
   var select=holder&&holder.querySelector('select.product__variant');
   var variant=article.querySelector('select.productSelect[name="id"]');
   if(!main||!rail||!select||!variant)return;
   var sources=arr(rail,'[data-ph-v7-thumb][data-ph-v7-full]').map(function(b){
     var img=b.querySelector('img'),alt=img&&img.alt||'',src=b.getAttribute('data-ph-v7-full');
     return {button:b,id:b.getAttribute('data-ph-v7-thumb'),kind:kind(alt),src:src,
       small:img&&img.src||'',alt:alt};
   }).filter(function(m){return m.id&&m.kind&&m.src;});
   if(['black','amber','wenge'].filter(function(k){
     return sources.some(function(m){return m.kind===k;});
   }).length<2)return;
   article.dataset.phSelectedFrameMounted='1';
   var stage=document.createElement('div');
   stage.className='ph-selected-frame-media-stage';
   stage.setAttribute('data-ph-selected-frame-media-stage','');
   stage.hidden=true;
   var photo=document.createElement('img');
   photo.className='ph-selected-frame-media-image';
   photo.loading='eager';photo.decoding='async';photo.alt='';
   var message=document.createElement('span');
   message.className='ph-selected-frame-media-loading';message.hidden=true;
   var zoom=document.createElement('button');
   zoom.type='button';zoom.className='ph-selected-frame-media-zoom';
   zoom.setAttribute('aria-label',/^he/i.test(document.documentElement.lang||'')?'הגדלת תמונת המוצר':'Enlarge product photo');
   zoom.innerHTML='<svg viewBox="0 0 26 26" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7.5" stroke="currentColor" stroke-width="1.7"/><path d="M16.6 16.6L23 23M11 7.5v7M7.5 11h7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
   zoom.hidden=true;
   stage.appendChild(photo);stage.appendChild(message);stage.appendChild(zoom);main.appendChild(stage);
   var token=0,shown='',pending='',current='',imageURL='',frame=0;
   var dialog=null,dialogImg=null;
   function caption(en,he){return /^he/i.test(document.documentElement.lang||'')?he:en;}
   function size(){
     if(stage.hidden)return;
     var g=article.querySelector('.product__gallery');
     if(!g)return;
     var width=g.getBoundingClientRect().width||g.clientWidth,top=main.getBoundingClientRect().top||0;
     var avail=Math.max(280,(window.innerHeight||800)-Math.max(top,100)-(window.innerWidth>=1024?100:28));
     var px=Math.floor(Math.min(width,avail,820));
     if(px>=200&&main.style.getPropertyValue('--ph-selected-frame-square')!==px+'px')
       main.style.setProperty('--ph-selected-frame-square',px+'px');
   }
   function visible(on){
     if(on&&article.classList.contains('ph-auto-frame-active'))on=false;
     stage.hidden=!on;
     article.classList.toggle('ph-preview-has-selected-media',on);
     if(on)size();
     else main.style.removeProperty('--ph-selected-frame-square');
     return on;
   }
   function desired(){
     var k=kind(select.value);
     if(!k)return null;
     var opt=variant.options[variant.selectedIndex];
     var mediaId=opt&&opt.getAttribute('data-media-id');
     return sources.find(function(s){return s.id===mediaId&&s.kind===k;})||
            sources.find(function(s){return s.kind===k;})||null;
   }
   function mark(s){
     sources.forEach(function(m){
       m.button.setAttribute('data-ph-selected-frame-media',m===s?'true':'false');
     });
   }
   function ready(s,url){
     if(!visible(true))return;
     current=s.id;shown=s.id;pending='';imageURL=url;
     stage.classList.remove('is-loading');photo.style.visibility='visible';
     message.hidden=true;zoom.hidden=false;mark(s);
   }
   function error(s){
     if(!visible(true))return;
     current=s.id;shown='';pending='';
     stage.classList.add('is-loading');photo.style.visibility='hidden';zoom.hidden=true;
     message.hidden=false;message.textContent=caption('Product image temporarily unavailable','התמונה אינה זמינה כרגע');
     mark(s);
   }
   function load(s){
     var id=s.id;
     if(id===shown&&photo.complete&&photo.naturalWidth>40){visible(true);mark(s);return;}
     if(id===pending)return;
     var seq=++token;current=id;pending=id;
     if(!visible(true))return;
     stage.classList.add('is-loading');photo.style.visibility='hidden';
     message.textContent=caption('Loading photo…','טוענים תמונה…');
     message.hidden=false;zoom.hidden=true;mark(s);
     function attempt(url,low){
       var preload=new Image();
       preload.onload=function(){
         if(seq!==token||!article.isConnected)return;
         if(preload.naturalWidth<40){failed();return;}
         photo.onload=function(){if(seq===token&&article.isConnected)ready(s,url);};
         photo.onerror=failed;photo.alt=s.alt;photo.src=url;
         if(photo.complete&&photo.naturalWidth>40)ready(s,url);
       };
       function failed(){
         if(seq!==token||!article.isConnected)return;
         if(!low&&s.small&&s.small!==url)attempt(s.small,true);
         else error(s);
       }
       preload.onerror=failed;preload.src=url;
     }
     attempt(s.src,false);
   }
   function sync(){
     frame=0;
     if(article.classList.contains('ph-auto-frame-active')){visible(false);return;}
     var s=desired();
     if(!s){++token;current='';shown='';pending='';visible(false);return;}
     if(current===s.id&&pending===s.id)return;
     if(current===s.id&&shown===s.id&&photo.complete&&photo.naturalWidth>40){
       visible(true);mark(s);return;
     }
     load(s);
   }
   function queue(){if(!frame)frame=window.requestAnimationFrame(sync);}
   function change(){
     queue();
     window.setTimeout(queue,75);
     window.setTimeout(queue,220);
   }
   select.addEventListener('change',change);
   variant.addEventListener('change',change);
   if(window.jQuery&&window.jQuery.fn){
     window.jQuery(select).on('change.phFrameMedia',change);
     window.jQuery(variant).on('change.phFrameMedia',change);
   }
   article.addEventListener('click',function(e){
     if(e.target.closest('.ph-v2__option--frame'))window.requestAnimationFrame(change);
   });
   rail.addEventListener('click',function(e){
     var button=e.target.closest('[data-ph-v7-thumb]');
     if(!button)return;
     var source=sources.find(function(s){return s.button===button;});
     if(!source)return;
     var option=arr(select,'option').find(function(opt){return kind(opt.value)===source.kind;});
     if(!option)return;
     var choice=arr(article,'.ph-v2__option--frame[data-ph-v2-value]').find(function(x){
       return x.getAttribute('data-ph-v2-value')===option.value;
     });
     e.preventDefault();e.stopImmediatePropagation();
     if(option.disabled||(choice&&choice.disabled))return;
     if(select.value===option.value){queue();return;}
     if(choice)choice.click();
     else {
       select.value=option.value;
       if(window.jQuery&&window.jQuery.fn)window.jQuery(select).trigger('change');
       else select.dispatchEvent(new Event('change',{bubbles:true}));
     }
     change();
   },true);
   if(window.MutationObserver){
     var native=main.querySelector('.filter_product_gallery');
     if(native)new MutationObserver(queue).observe(native,{childList:true,subtree:false});
   }
   window.addEventListener('resize',function(){size();queue();},{passive:true});
   zoom.addEventListener('click',function(){
     if(!shown||!imageURL||!window.HTMLDialogElement)return;
     if(!dialog){
       dialog=document.createElement('dialog');dialog.className='ph-qa-media-dialog';
       var close=document.createElement('button');close.type='button';
       close.className='ph-qa-media-close';close.textContent='×';
       close.setAttribute('aria-label',caption('Close','סגירה'));
       dialogImg=document.createElement('img');dialogImg.className='ph-qa-media-image';
       dialog.appendChild(close);dialog.appendChild(dialogImg);document.body.appendChild(dialog);
       close.addEventListener('click',function(){dialog.close();});
       dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close();});
       dialog.addEventListener('close',function(){zoom.focus();});
     }
     dialogImg.src=imageURL;dialogImg.alt=photo.alt;
     if(!dialog.open)dialog.showModal();
   });
   sync();
 }
 function start(){
   if(!document.body||!document.body.classList.contains('ph-v1')||
      !document.body.classList.contains('template-product')||
       document.body.classList.contains('template-product-portfolio'))return;
   arr(document,'article.product.page-section').forEach(mount);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
 else start();
 document.addEventListener('shopify:section:load',start);
}());
